import { portalLink } from "../utils/portal";


function Listings() {
  const handleApply = () => {
    window.location.href = portalLink("/student-login");
  };

  const listings = [
    {
      id: 1,
      logo: "DH",
      company: "Dwellora Homes",
      location: "Pune, India",
      title: "Architect",
      tags: ["Lumion", "AutoCAD", "SketchUp"],
      salary: "₹2–5 LPA",
    },
    {
      id: 2,
      logo: "IS",
      company: "Isha Associates",
      location: "Pune, India",
      title: "BIM Architect — Revit Lead",
      tags: ["Revit", "BIM 360", "5+ Yrs"],
      salary: "₹8–12 LPA",
    },
    {
      id: 3,
      logo: "SP",
      company: "Studio Projection",
      location: "Pune, India",
      title: "Senior Architect",
      tags: ["Municipal Drawing", "5+ Yrs", "Autocad"],
      salary: "₹10–15 LPA",
    },
  ];

  return (
    <section className="listings" id="listings">
      <div className="lst-intro">
        <div className="eyebrow rv">
          <div className="eyebrow-dash"></div>
          <span className="eyebrow-text">Featured Opportunities</span>
        </div>
        <h2 className="sec-title rv d1">
          Latest <em> Openings </em> and Programs.
        </h2>
      </div>
      <div className="listings-tabs rv">
        <div className="ltab active" data-ltab="jobs">
          Latest Jobs
        </div>
        {/* <div className="ltab" data-ltab="programs">Upcoming Programs</div>
        <div className="ltab" data-ltab="events">Industry Events</div> */}
      </div>
      <div className="listings-grid rv" id="listingsGrid">
        {listings.map((item) => (
          <div className="listing-card" key={item.id}>
            <div className="listing-type">● Full Time</div>
            <div className="listing-company">
              <div className="listing-logo">{item.logo}</div>
              <div>
                <div className="listing-co-name">{item.company}</div>
                <div className="listing-co-loc">{item.location}</div>
              </div>
            </div>
            <div className="listing-title">{item.title}</div>
            <div className="listing-tags">
              {item.tags.map((tag, i) => (
                <span className="listing-tag" key={i}>
                  {tag}
                </span>
              ))}
            </div>
            <div
              className="listing-foot"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "nowrap",
                gap: "8px",
                width: "100%",
              }}
            >
              <div
                className="listing-salary"
                style={{
                  whiteSpace: "nowrap",
                  fontSize: "clamp(0.8rem, 3.2vw, 1rem)",
                  flexShrink: 1,
                  minWidth: 0,
                }}
              >
                {item.salary}
              </div>
              <button
                type="button"
                className="listing-apply"
                onClick={handleApply}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "4px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  flexGrow: 0,
                  width: "auto",
                  marginLeft: "auto",
                  textAlign: "right",
                }}
              >
                Apply{" "}
                <span className="listing-apply-arrow">
                  <svg
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="2"
                    width="13"
                    height="13"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        ))}
      </div>
      {/* <div className="lst-more rv">
        <a href="/jobs" className="btn btn-out">
          View All 100+ Openings
          <svg
            viewBox="0 0 24 24"
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            width="13"
            height="13"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </a>
      </div> */}


<div
  className="lst-more rv"
  style={{ marginTop: "80px" }}
>
  <a href="/jobs" className="btn btn-out">
    View All 100+ Openings
    <svg
      viewBox="0 0 24 24"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      width="13"
      height="13"
    >
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  </a>
</div>


    </section>
  );
}

export default Listings;